import { render, staticRenderFns } from "./Organisation.vue?vue&type=template&id=2a7f2295&scoped=true&"
import script from "./Organisation.vue?vue&type=script&lang=js&"
export * from "./Organisation.vue?vue&type=script&lang=js&"
import style0 from "./Organisation.vue?vue&type=style&index=0&id=2a7f2295&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a7f2295",
  null
  
)

export default component.exports